import React, { useContext, useState } from 'react';
import AntButton, { ButtonProps as AntButtonProps } from 'antd/lib/button';
import useComponentConfiguration from 'DisplayFramework/useComponentConfiguration';
import { Input, notification } from 'antd';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';
import { SaveOutlined } from '@ant-design/icons';
import { ParPagComponentRequest, updatePageComponent } from 'services/displayFramework';
import { AuthContext } from 'components/Auth/Auth';
import RouterLink from 'components/RouterLink';

export type ButtonProps = Omit<AntButtonProps, 'children'> & {
  to?: string; // Si fourni, rendra un RouterLink
  comcode: string;
  custom?: any;
  Inspectstyle?: React.CSSProperties;
  onlyIcon?: boolean;
  icon?: React.ReactNode;
  type?: "default" | "primary" | "dashed" | "link" | "text";
};

const ButtonLink = ({
  comcode,
  custom,
  Inspectstyle,
  onlyIcon,
  icon,
  type,
  className,
  to,
  ...otherProps
}: ButtonProps) => {
  const { isInspect } = useContext(AuthContext);
  const { isHidden, label, style } = useComponentConfiguration(comcode);
  const { pagcode, refresh } = useDisplayFrameworkContext();
  const [newLabel, setNewLabel] = useState('');

  if (isHidden) {
    return null;
  }

  const handleSaveNewLabel = (comcode: string, labelp: string) => {
    const request: ParPagComponentRequest = {
      comcode: comcode ?? '',
      comformat: '',
      comhint: '',
      comlabel: newLabel === '' ? label : labelp,
      commessage: '',
      complaceholder: '',
      comrequired: false,
      comstyle: '',
      comtype: '',
      pagcode: pagcode ?? '',
    };
    updatePageComponent({ request }).then((res) => {
      if (res.code === '200') {
        notification.success({
          message: res.message,
          description: res.description,
        });
      } else {
        notification.error({
          message: res.message,
          description: res.description,
        });
      }
      refresh();
    });
  };

  const buttonContent = isInspect ? (
    <Input
      defaultValue={label === '' ? comcode : label}
      size="middle"
      onChange={(event) => {
        event.preventDefault();
        setNewLabel(event.target.value);
      }}
      onClick={(event) => {
        event.preventDefault();
      }}
      style={Inspectstyle ?? { width: '80%' }}
      className="input-inspect"
      addonAfter={
        <SaveOutlined
          onClick={(ev) => {
            ev.preventDefault();
            handleSaveNewLabel(comcode, newLabel);
          }}
        />
      }
    />
  ) : onlyIcon ? '' : label;

  // Si une propriété `to` est fournie, utiliser RouterLink
  if (to) {
    return (
      <RouterLink to={!isInspect ? to : undefined}>
        <AntButton
          {...otherProps}
          type={type}
          icon={icon}
          className={`ut-submit-btn ${className}`}
        >
          {buttonContent}
        </AntButton>
      </RouterLink>
    );
  }

  // Sinon, retourner un bouton standard
  return (
    <AntButton

      {...otherProps}
      style={style}
      icon={icon}
      type={type}
      className={`ut-submit-btn ${className}`}
    >
      {buttonContent}
    </AntButton>
  );
};

export default ButtonLink;
